import { useFormContext } from 'react-hook-form'
import { stylesFieldForms } from '../styles'
import { FieldsDescricaoNotaFiscalProps } from './FieldsDescricaoNotaFiscal.View'

// eslint-disable-next-line no-empty-pattern
export function fieldsDescricaoNotaFiscalIO({}: FieldsDescricaoNotaFiscalProps) {
  const { control } = useFormContext()

  return {
    styles: stylesFieldForms,
    control
  }
}

export type FieldsDescricaoNotaFiscalIO = ReturnType<typeof fieldsDescricaoNotaFiscalIO>
